// src/lib/reviewsApi.js
// Client for reading product reviews. getReviews() talks to a Netlify Function
// (netlify/functions/reviews.js) that proxies Judge.me server-side, since Judge.me's
// raw review data requires a private API token that must never reach the browser bundle.

export async function getReviews({ productId, limit } = {}) {
    const params = new URLSearchParams();
    if (productId) params.set('productId', productId);
    if (limit) params.set('limit', limit);
    try {
        const response = await fetch(`/.netlify/functions/reviews?${params.toString()}`);
        if (!response.ok) return [];
        const data = await response.json();
        return Array.isArray(data) ? data : [];
    } catch (err) {
        console.error('[Reviews] Failed to fetch reviews:', err);
        return [];
    }
}

// Sends a review to Judge.me via the same Netlify Function. Resolves to
// { ok: true } or { ok: false, error } — never throws.
export async function submitReview({ productId, rating, name, email, title, body, website }) {
    try {
        const response = await fetch('/.netlify/functions/reviews', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ productId, rating, name, email, title, body, website }),
        });
        const data = await response.json().catch(() => ({}));
        return response.ok ? { ok: true } : { ok: false, error: data.error || 'Something went wrong. Please try again.' };
    } catch (err) {
        console.error('[Reviews] Failed to submit review:', err);
        return { ok: false, error: 'Something went wrong. Please try again.' };
    }
}

export async function getStoreRating() {
    try {
        const response = await fetch('/.netlify/functions/reviews?summary=store');
        if (!response.ok) return null;
        const data = await response.json();
        return data
            && typeof data.average === 'number'
            && typeof data.count === 'number'
            ? data
            : null;
    } catch (err) {
        console.error('[Reviews] Failed to fetch store rating:', err);
        return null;
    }
}
